import { render, staticRenderFns } from "./PriceQuotationInfoPropertyTypesInfo.vue?vue&type=template&id=f50fc538&"
import script from "./PriceQuotationInfoPropertyTypesInfo.vue?vue&type=script&lang=js&"
export * from "./PriceQuotationInfoPropertyTypesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports